import "./App.css";
import FeatureGraphic from "./assets/images/feature_graphic.png";
import Seo from "./components/Seo.js";

function App() {
    return (
        <div className="container">
            <Seo />
            <div className="dialog">
                <h1 className="title">Birthday Reminder</h1>
                <h3>Never Forget a Birthday Again!</h3>
                <p className="description">
                    Get reminders for your birthdays and celebrate every special
                    moment. Download the app today!
                </p>
                <a
                    href="https://play.google.com/store/apps/details?id=com.nunoreis.birthdayreminder"
                    className="download-button"
                >
                    Download on Google Play
                </a>
                <img
                    src={FeatureGraphic}
                    alt="Birthday Reminder App Screenshot"
                    className="screenshot"
                />
            </div>
        </div>
    );
}

export default App;
